'use client';
import React, { useState } from 'react';
import Image from 'next/image';
import { SlideshowLightbox } from 'lightbox.js-react';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';

import { type Cover } from '@/lib/types/customer/restaurant/StoreProfile';

import 'swiper/css';
import 'swiper/css/navigation';

const storeData = [
  {
    id: 1,
    url: '/store/cover-placeholder-1.png',
    thumb_url: '/products-slider/hoverThumb.png',
    relation_name: '',
    order_index: 1,
  },
  {
    id: 2,
    url: '/store/cover-placeholder-4.png',
    thumb_url: '/products-slider/hoverThumb.png',
    relation_name: '',
    order_index: 2,
  },
  {
    id: 3,
    url: '/store/cover-placeholder-3.png',
    thumb_url: '/products-slider/hoverThumb.png',
    relation_name: '',
    order_index: 3,
  },
  {
    id: 4,
    url: '/store/cover-placeholder-2.png',
    thumb_url: '/products-slider/hoverThumb.png',
    relation_name: '',
    order_index: 4,
  },
];

interface StoreSliderProps {
  cover: Cover[] | null;
}

const StoreSlider = ({ cover }: StoreSliderProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [lightboxIndex, setLightboxIndex] = useState<number>(0);

  const slides: Cover[] = cover ? cover : storeData;
  const galleryImages = slides.map((item) => ({
    src: item.url,
    alt: item.relation_name || 'Store image',
  }));

  const showLightbox = (index: number) => {
    setLightboxIndex(index);
    setIsOpen(true);
  };

  return (
    <>
      <Swiper
        modules={[Navigation]}
        spaceBetween={2}
        slidesPerView={1}
        navigation
        className="store-slider sm:[280px] h-[214px] bg-white md:h-[320px] xl:h-[400px]"
        breakpoints={{
          340: {
            slidesPerView:
              slides?.length <= 1 ? 1 : slides?.length <= 2 ? 2 : 2.5,
          },
          768: {
            slidesPerView:
              slides?.length <= 1
                ? 1
                : slides?.length <= 2
                ? 2
                : slides?.length <= 3
                ? 3
                : 3.5,
          },
          1024: {
            slidesPerView:
              slides?.length <= 1
                ? 1
                : slides?.length <= 2
                ? 2
                : slides?.length <= 3
                ? 3
                : slides?.length <= 4
                ? 4
                : 4,
          },
        }}
      >
        {slides?.map((slide: Cover, i) => (
          <SwiperSlide key={slide?.url + i}>
            <button
              onClick={() => showLightbox(i)}
              className="slide-card relative h-full w-full overflow-hidden"
            >
              <Image
                src={slide?.url}
                alt={`${slide?.relation_name} cover ${i}`}
                className="thumb h-full w-full object-cover"
                width={400}
                height={400}
                sizes="100vw"
              />
              <Image
                src={slide?.thumb_url}
                alt={`${slide?.relation_name} thumb ${i}`}
                width={400}
                height={400}
                sizes="100vw"
                className="thumb absolute left-0 top-0 h-full w-full object-cover opacity-0"
              />
            </button>
          </SwiperSlide>
        ))}
      </Swiper>
      <SlideshowLightbox
        images={galleryImages}
        showThumbnails={true}
        open={isOpen}
        startingSlideIndex={lightboxIndex}
        lightboxIdentifier="store-lightbox"
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};

export default StoreSlider;
